import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UIDialogConfirmData } from './dialog-confirm-data.interface';

@Component({
  selector: 'ui-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIDialogConfirmComponent {
  private readonly dialogRef = inject<MatDialogRef<UIDialogConfirmComponent>>(MatDialogRef);
  data = inject<UIDialogConfirmData>(MAT_DIALOG_DATA);

  get title(): string {
    return this.data.title;
  }

  get description(): string {
    return this.data.description;
  }

  get confirmButtonText(): string {
    return this.data.confirmButtonText ?? 'Confirm';
  }

  get cancelButtonText(): string {
    return this.data.cancelButtonText ?? 'Back';
  }

  confirmButton(): void {
    this.dialogRef.close(true);
  }

  cancelButton(): void {
    this.dialogRef.close(false);
  }
}
